const summaryPageConstants = {
  SUMMARY_PAGE: {
    TITLE: 'Summary',
    SUBTITLE: {
      PART1: 'Take an in-depth look at your population health from ',
      PART2: ' to ',
      PART3: ' to plan intervention strategy',
    },
    SUMMARY_CARDS: {
      TOTAL_ELIGIBLE: 'Total Eligible',
      TOTAL_ENROLLED: 'Total Enrolled',
      TOTAL_COST: 'Total Cost',
      EMPLOYEES: 'Employees',
      DEPENDENTS: 'Dependents',
      TOTAL_SPEND: 'Total Plan Spend',
      EMPLOYEE_SPEND: 'Employees Spend',
      DEPENDENT_SPEND: 'Dependent Spend',
      AVERAGE_AGE: 'Average Age',
      ALL_MEMBERS: 'All Members',
      GENDER: 'Gender',
      PMPM: 'PMPM',
      PEPM: 'PEPM',
      RISK_STRATIFICATION_CUMULATIVE_LABELS: {
        LABEL1: 'Highly Complex Group (6+ chronic conditions)',
        LABEL1_INFO:
          'Implement intensive care management for the most complex healthcare needs.',
        LABEL2: 'High Risk Group (4-5 chronic conditions)',
        LABEL2_INFO:
          'Focus on risk reduction strategies and regular monitoring to prevent complications.',
        LABEL3: 'Rising Risk Group (2-3 chronic conditions)',
        LABEL3_INFO:
          'Emphasize preventive measures and early intervention to avoid high-risk status.',
        LABEL4: 'Moderate Risk Group (1 chronic condition)',
        LABEL4_INFO:
          'Support disease management and health maintenance for moderate-risk individuals.',
        LABEL5: 'Low Risk Group (0 chronic conditions)',
        LABEL5_INFO:
          'Promote preventive care and healthy lifestyle choices for individuals with no chronic conditions.',
      },
      RISK_STRATIFICATION_LABELS: {
        TITLE: 'Risk Profile By Chronic Condition',
        TITLE1: 'Risk Profile By Other Categories',
        SUBTITLE_1:
          'You can use the toggle on the right to see risk stratification based on other factors',
        SUBTITLE_2: 'Shows different factors contributing to risk of a patient',
        CLICK_HERE: 'View Breakdown',
        LEFT_VALUE: 'Chronic Prevalence',
        RIGHT_VALUE: 'Other Factors',
        TOOLTIP:
          'A "one-size-fits-all" model, where the same level of resources is offered to every patient, is clinically ineffective and prohibitively expensive. Risk stratification enables care managers to identify the right level of care and services for distinct subgroups of patients. It is the process of assigning a risk status to patients, then using this information to direct care and improve overall health outcomes.',
      },
      RISK_STRATIFICATION_LABELS_EXP: {
        TITLE: 'Risk Profile By Chronic Condition',
        TITLE1: 'Risk Profile By Other Categories',
        SUBTITLE_1: '',
        SUBTITLE_2: '',
        CLICK_HERE: 'View Breakdown',
        LEFT_VALUE: 'Chronic Prevalence',
        RIGHT_VALUE: 'Other Factors',
        TOOLTIP:
          'A "one-size-fits-all" model, where the same level of resources is offered to every patient, is clinically ineffective and prohibitively expensive. Risk stratification enables care managers to identify the right level of care and services for distinct subgroups of patients. It is the process of assigning a risk status to patients, then using this information to direct care and improve overall health outcomes.',
      },
      RISK_INDEX: {
        TITLE: 'Risk Index',
        TOOLTIP:
          "Risk Index takes into account each member's diagnoses, medications, chronic conditions, and other factors to establish an individualized score. Those scores are then combined and normalized to a value between zero and two.",
      },
      MLR: {
        TITLE: 'MLR',
        TOOLTIP:
          'Medical Loss Ratio is a critical financial metric used in healthcare insurance and self-insured groups. It represents the ratio of total healthcare claims and expenses incurred to the total premiums or contributions received within a specific period. This percentage helps assess the efficiency of healthcare cost management and financial sustainability, with lower ratios indicating more effective cost control. For self-insured groups, it measures how well contributions cover healthcare expenses.',
      },
      HIGH_COST_CLAIMANTS: {
        TITLE: 'High Cost Claimants',
        SUB_TITLE: 'Showing share of high cost claimants',
        CLICK_HERE: 'Click Here',
      },
      COST_TREND: {
        TITLE: 'Total Cost Trend (Plan Paid + Member Paid)',
        SUB_TITLE: 'To see more about plan cost distribution',
      },
      DISEASE_PREVALENCE: {
        TITLE: 'Top Disease Prevalence by',
        SUB_TITLE: 'To see more about disease prevalence',
        DROPDOWN_OPTIONS: ['Member', 'Cost'],
        CLICK_HERE: 'Click Here',
      },
      PHARMACY_USAGE: {
        TITLE: 'Top Pharmacy Usage by',
        SUB_TITLE: 'To see more about pharmacy utilization',
        DROPDOWN_OPTIONS: ['Member', 'Cost'],
      },
      UTILIZATION_PER_100: {
        TITLE: 'Top Services by',
        SUB_TITLE: 'To see more about admission utilization',
        DROPDOWN_OPTIONS: ['Member', 'Cost'],
        CLICK_HERE: 'Click Here',
      },
    },
    COHORT_DETAILS: {
      TITLE: 'Cohort Details',
      SUBTITLE:
        'Select the properties that you would like to apply to current data',
    },
  },
};

export default summaryPageConstants;
